import React from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class ResidentType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: 0,
            options: [
                {
                    value: 0,
                    label: 'Normal',
                },
                {
                    value: 1,
                    label: 'Knowledge Worker',
                },
                {
                    value: 2,
                    label: 'Returning Expert Program',
                }
            ]
        };
    }

    handleChange = ({ value }) => {
        if (this.props.handleChange) {
            this.props.handleChange(value);
        }

        this.setState(Object.assign({},
            this.state,
            {
                type: value
            }
        ));
    }

    render() {
        const { type } = this.state;

        return (
            <div className='resident-type pcb-select'>
                <label>
                    Type of Resident <i
                        className="fa fa-question-circle"
                        data-tip="See help article for more info:
                            <a href='http://help.payrollpanda.my/12465-malaysia-payroll-faq/which-employees-can-benefit-from-special-tax-incentives' target='_blank'>
                                Which employees can benefit from special tax incentives?
                            </a>"
                    >
                    </i>
                </label>

                <Select
                    name="form-field-name"
                    value={type}
                    onChange={this.handleChange}
                    options={this.state.options}
                    searchable={false}
                    clearable={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/ResidentType.js